var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headerWrapper bar",class:{'androidStyle':!_vm.ISANDROID}},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"returnIcon",on:{"click":_vm.backTo}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n      移动办公\n    ")]),_vm._v(" "),(_vm.showPerson)?_c('div',{staticClass:"addPerson"}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0acca5d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VHeaderOld.vue
// module id = null
// module chunks = 